'use strict';

module.exports = lineBreak;

var map = {true: '\\\n', false: '  \n'};

function lineBreak() {
  return map[this.options.commonmark];
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/break.js
// module id = 290
// module chunks = 96961042003272 139266963665775